export enum FieldNames {
  Sectors = 'sectors',
  Sites = 'sites',
  Equipment = 'equipment',
  FormCategories = 'formCategories',
  Reset = 'reset',
}
